import { useEffect, useState } from "react";

/**
 * Whether the viewport is at or below `maxWidth`.
 *
 * A media query rather than a width check on resize: matchMedia only fires
 * when the answer actually changes, so this does not re-render on every pixel
 * of a drag.
 *
 * 991 is the breakpoint the stylesheets already switch on, so layout decisions
 * taken in JS land on the same side of the line as the CSS.
 */
export default function useIsNarrowViewport(maxWidth = 991): boolean {
  const query = `(max-width: ${maxWidth}px)`;
  const [isNarrow, setIsNarrow] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches
  );

  useEffect(() => {
    const list = window.matchMedia(query);
    const update = (event: MediaQueryListEvent) => setIsNarrow(event.matches);
    setIsNarrow(list.matches);
    list.addEventListener("change", update);
    return () => list.removeEventListener("change", update);
  }, [query]);

  return isNarrow;
}
